import React, { useState, useMemo } from 'react'
import { withTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment-timezone'
import ContinueCancelButtons from 'shared/components/ContinueCancelButtons'
import BackAnchor from 'shared/components/BackAnchor'
import BusinessName from './BusinessName'
import MasterNumber from './MasterNumber'
import { listAddAction, listEditAction } from 'redux/actions';
import { findDuplicateMasterNumber } from "../../../../redux/reducers/appReducer";

const BusinessVehicleInformationView = ({ t, i18n, setIsError }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const timezone = process.env.REACT_APP_TIME_ZONE.toString()
  moment.tz.setDefault(timezone)

  const [businessNameValid, setBusinessNameValid] = useState('')
  const [masterNumberValid, setMasterNumberValid] = useState('')

  const [businessNameError, setBusinessNameError] = useState('business_vehicle_info.business_name_error')
  const [masterNumberError, setMasterNumberError] = useState('business_vehicle_info.master_number_error')

  const { businessName, masterNumber, editMasterNumber } = useSelector((state) => state.app.businessVehicleInformation)

  const [errMsg, setErrMsg] = useState('');
  const houseHoldMembers = useSelector((state) => state.app.personalInformation.houseHoldMembers);
  const jointVehicles = useSelector((state) => state.app.jointlyOwnedVehicleInformation.vehicles);
  const businessVehicles = useSelector((state) => state.app.businessVehicleInformation.businessVehicles);


  const isSummary = useMemo(() => {
    return JSON.parse(new URLSearchParams(history.location.search).get("isSummary") ?? false);
  }, [history]);

  // useEffect(() => {
  //   try {
  //     if (!nsHealthCard && !driverLicence && !vehiclePermit && !registeredByName) {
  //       history.push(`/${i18n.language}${t('routes.address_type_change')}`)
  //     }
  //   } catch (e) {
  //     console.log(e)
  //     setIsError(true)
  //   }
  // }, [])

  const onNext = () => {
    try {
      if (validateFields()) {
        if (editMasterNumber) {
          dispatch(
            listEditAction('businessVehicleInformation', {
              businessName, masterNumber
            })
          );
        } else {
          if (findDuplicateMasterNumber(masterNumber, houseHoldMembers, jointVehicles, businessVehicles)) {
            setErrMsg('household_list.found_duplicate')
            return;
          }
          dispatch(listAddAction("businessVehicleInformation", {
            businessName, masterNumber
          }));
        }
        if (isSummary) {
          history.push(`/${i18n.language}${t('routes.review_summary')}`)
        } else {
          history.push(`/${i18n.language}${t('routes.business_vehicle_info_summary')}`)
        }


      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateFields = () => {
    try {
      validateBusinessName(businessName)
      validateMasterNumber(masterNumber)

      if (businessName === '') {
        setBusinessNameValid(false)
      }
      if (masterNumber === '') {
        setMasterNumberValid(false)
      }

      return (
        businessNameValid === true &&
        masterNumberValid === true &&

        businessName !== '' &&
        masterNumber !== ''
      )
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateBusinessName = (name) => {
    try {
      const regex = RegExp(/^[a-zA-Z0-9-`‘’'àâäèéêëîïôœùûüÿçÀÂÄÈÉÊËÎÏÔŒÙÛÜŸÇ& ]*$/)
      if (name.length > 0) {
        if (regex.test(name)) {
          setBusinessNameValid(true)
        } else {
          setBusinessNameValid(false)
          setBusinessNameError('business_vehicle_info.business_name_error_invalid')
        }
      } else {
        setBusinessNameValid(false)
        setBusinessNameError('business_vehicle_info.business_name_error')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }

  const validateMasterNumber = (number) => {
    try {
      if (!number) {
        setMasterNumberValid(false)
        setMasterNumberError('business_vehicle_info.master_number_error')
        return;
      }
      const regex = RegExp(/^[a-zA-Z\s]{5}[0-9]{9}$/i)
      if (regex.test(number)) {
        setMasterNumberValid(true)
      } else {
        setMasterNumberValid(false)
        setMasterNumberError('business_vehicle_info.master_number_error_invalid')
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
  }


  return (
    <div className="container">
      <main>
        <article>
          <BackAnchor />
          <div className="row">
            <div className="col-xs-12 col-lg-12">
              <h1>{t('business_vehicle_info.title')}</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-12">
              <BusinessName
                validateBusinessName={validateBusinessName}
                businessNameError={businessNameError}
                businessNameValid={businessNameValid}
                setIsError={setIsError}
              />
              <MasterNumber
                validateMasterNumber={validateMasterNumber}
                masterNumberError={masterNumberError}
                masterNumberValid={masterNumberValid}
                setIsError={setIsError}
              />
            </div>
          </div>
          <ContinueCancelButtons continueClick={onNext} errorText={errMsg} />
        </article>
      </main>
    </div>
  )
}

export default withTranslation('common')(BusinessVehicleInformationView)
